import React from 'react';

export const LoadingView = () => {
  return (
    <div className="loading-container">
      <div className="loading-wrapper">
        <div className="center_container loading-icon-container">
          <img src="/static/images/icon/loading_icon_green.svg" alt="loading_icon" className="loading_icon-image" />
        </div>
        <div className="loading-text-main">Loading<div className="loading-text" data-text="...">...</div></div>
      </div>
    </div>
  )
}